module.exports = __webpack_public_path__ + "media/images/top-f3e649521550197a13562ca8767c005b.png";